
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/verdskra",
      function () {
        return require("private-next-pages/verdskra.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/verdskra"])
      });
    }
  